const DOMAIN = "https://www.adriaticasrlbolognacostruzioni.com";

export const SERVICES = {
  ristrutturazioni: {
    slug: "ristrutturazioni",
    metaTitle: "Ristrutturazioni a Bologna | Appartamenti, Condomini e Locali — Adriatica S.r.l.",
    metaDescription:
      "Ristrutturazioni complete a Bologna e provincia: appartamenti, condomini, locali commerciali ed edifici storici. Detrazioni fiscali e lavori chiavi in mano con Adriatica S.r.l. Semplificata.",
    breadcrumb: "Ristrutturazioni",
    breadcrumbEn: "Renovations",
    h1: "Ristrutturazioni complete a Bologna",
    h1En: "Complete renovations in Bologna",
    intro: "Valorizziamo gli spazi, miglioriamo la qualità della vita.",
    introEn: "We enhance spaces, we improve quality of life.",
    heroImg:
      "https://images.pexels.com/photos/30211382/pexels-photo-30211382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    heroAlt: "Interno ristrutturato da Adriatica S.r.l. a Bologna",
    body: [
      "Ristrutturare significa dare nuova vita a un immobile: che si tratti di un appartamento, di un condominio, di un locale commerciale o di un edificio storico, Adriatica S.r.l. Semplificata segue ogni intervento con la stessa cura, dal primo sopralluogo alla consegna finale.",
      "Con oltre vent'anni di esperienza nel settore edile a Bologna e provincia, coordiniamo direttamente tutte le fasi del cantiere: demolizioni e ricostruzioni, opere murarie, rifacimento degli impianti, finiture e dettagli. Un unico interlocutore, un unico responsabile dei tempi e dei costi.",
    ],
    bodyEn: [
      "Renovating means giving new life to a property: whether it's an apartment, a condominium, a commercial space or a historic building, Adriatica S.r.l. Semplificata follows every project with the same care, from the first site visit to final delivery.",
      "With over twenty years of construction experience in Bologna and its province, we directly coordinate every phase of the worksite: demolitions and rebuilds, masonry, systems renewal, finishes and details. One single point of contact, one single party responsible for timing and costs.",
    ],
    includes: [
      "Ristrutturazione completa di appartamenti e ville",
      "Riqualificazione di condomini e parti comuni",
      "Ristrutturazione di locali commerciali e uffici",
      "Recupero e restauro di edifici storici",
      "Rifacimento di impianti idraulici ed elettrici",
      "Opere murarie, cartongesso, pavimenti e finiture",
    ],
    includesEn: [
      "Full renovation of apartments and villas",
      "Condominium and common areas refurbishment",
      "Renovation of commercial spaces and offices",
      "Recovery and restoration of historic buildings",
      "Renewal of plumbing and electrical systems",
      "Masonry, drywall, flooring and finishes",
    ],
    detrazioni: true,
  },
  "nuove-costruzioni": {
    slug: "nuove-costruzioni",
    metaTitle: "Nuove Costruzioni a Bologna | Edifici Residenziali e Commerciali — Adriatica S.r.l.",
    metaDescription:
      "Nuove costruzioni a Bologna e provincia: edifici residenziali, commerciali e direzionali. Soluzioni moderne, efficienti e sostenibili con Adriatica S.r.l. Semplificata.",
    breadcrumb: "Nuove Costruzioni",
    breadcrumbEn: "New Builds",
    h1: "Nuove costruzioni a Bologna",
    h1En: "New builds in Bologna",
    intro: "Soluzioni moderne, efficienti e sostenibili.",
    introEn: "Modern, efficient and sustainable solutions.",
    heroImg:
      "https://images.unsplash.com/photo-1599777560450-e462cffc5368?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGR1c2slMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkyNDM5NDI3fDA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Nuova costruzione residenziale realizzata da Adriatica S.r.l.",
    body: [
      "Costruire da zero è la nostra specialità: Adriatica S.r.l. Semplificata realizza edifici residenziali, commerciali e direzionali a Bologna e provincia, con un approccio orientato alla qualità costruttiva e all'efficienza energetica.",
      "Seguiamo il progetto in ogni fase: scavi e fondazioni, strutture portanti, murature, coperture, impianti e finiture. Ogni edificio è pensato per durare nel tempo, con materiali di prima scelta e soluzioni sostenibili che riducono i consumi.",
    ],
    bodyEn: [
      "Building from scratch is our specialty: Adriatica S.r.l. Semplificata constructs residential, commercial and office buildings in Bologna and its province, with an approach focused on construction quality and energy efficiency.",
      "We follow the project through every phase: excavation and foundations, load-bearing structures, masonry, roofing, systems and finishes. Every building is designed to last, with first-choice materials and sustainable solutions that reduce consumption.",
    ],
    includes: [
      "Edifici residenziali: villette, bifamiliari e condomini",
      "Edifici commerciali e direzionali",
      "Strutture in cemento armato e muratura portante",
      "Coperture, facciate e opere esterne",
      "Impianti efficienti e predisposizione fotovoltaico",
      "Soluzioni costruttive sostenibili e a basso consumo",
    ],
    includesEn: [
      "Residential buildings: villas, semi-detached houses and condominiums",
      "Commercial and office buildings",
      "Reinforced concrete and load-bearing masonry structures",
      "Roofing, facades and outdoor works",
      "Efficient systems and solar panel readiness",
      "Sustainable, low-consumption construction solutions",
    ],
    detrazioni: false,
  },
  impianti: {
    slug: "impianti",
    metaTitle: "Impianti Idraulici, Elettrici, Climatizzazione e Fotovoltaico a Bologna — Adriatica S.r.l.",
    metaDescription:
      "Impianti idraulici, elettrici, climatizzazione e fotovoltaico a Bologna: efficienza e innovazione per il tuo comfort. Installazioni a norma con Adriatica S.r.l. Semplificata.",
    breadcrumb: "Impianti e Tecnologia",
    breadcrumbEn: "Systems & Technology",
    h1: "Impianti e tecnologia a Bologna",
    h1En: "Systems and technology in Bologna",
    intro: "Efficienza e innovazione per il tuo comfort.",
    introEn: "Efficiency and innovation for your comfort.",
    heroImg:
      "https://images.unsplash.com/photo-1770391949357-3c27554d3a78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBpbnRlcmlvciUyMHJlbm92YXRpb24lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBzb2xhciUyMHBhbmVsJTIwYmx1ZXByaW50fGVufDB8fHx8MTc5MjQzOTQzNHww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Impianti fotovoltaici e tecnologie installate da Adriatica S.r.l.",
    body: [
      "Un edificio funziona bene quando i suoi impianti sono progettati e realizzati a regola d'arte. Adriatica S.r.l. Semplificata installa impianti idraulici, elettrici, di climatizzazione e fotovoltaici a Bologna e provincia, per abitazioni, uffici e attività commerciali.",
      "Ogni impianto è realizzato a norma e pensato per durare: attenzione ai materiali, alle prestazioni e ai consumi. Dal singolo intervento di manutenzione alla realizzazione completa in fase di costruzione o ristrutturazione.",
    ],
    bodyEn: [
      "A building works well when its systems are designed and built properly. Adriatica S.r.l. Semplificata installs plumbing, electrical, air conditioning and photovoltaic systems in Bologna and its province, for homes, offices and businesses.",
      "Every system is built to code and designed to last: attention to materials, performance and consumption. From a single maintenance job to complete installations during construction or renovation.",
    ],
    includes: [
      "Impianti idraulici e termoidraulici",
      "Impianti elettrici a norma",
      "Impianti di climatizzazione e riscaldamento",
      "Impianti fotovoltaici per il risparmio energetico",
      "Rifacimento impianti in ristrutturazione",
      "Manutenzione e assistenza post-intervento",
    ],
    includesEn: [
      "Plumbing and heating systems",
      "Electrical systems built to code",
      "Air conditioning and heating systems",
      "Photovoltaic systems for energy savings",
      "Systems renewal during renovations",
      "Maintenance and after-service support",
    ],
    detrazioni: false,
  },
  "chiavi-in-mano": {
    slug: "chiavi-in-mano",
    metaTitle: "Lavori Chiavi in Mano a Bologna | Dalla Progettazione alla Consegna — Adriatica S.r.l.",
    metaDescription:
      "Lavori chiavi in mano a Bologna: consulenza, progettazione, direzione lavori e gestione cantieri con un unico interlocutore. Adriatica S.r.l. Semplificata, senza pensieri.",
    breadcrumb: "Chiavi in Mano",
    breadcrumbEn: "Turnkey",
    h1: "Lavori chiavi in mano a Bologna",
    h1En: "Turnkey projects in Bologna",
    intro: "Dalla progettazione alla consegna, senza pensieri.",
    introEn: "From design to delivery, without worries.",
    heroImg:
      "https://images.pexels.com/photos/7641932/pexels-photo-7641932.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    heroAlt: "Progettazione tecnica di un lavoro chiavi in mano Adriatica S.r.l.",
    body: [
      "Con la formula chiavi in mano hai un unico interlocutore per tutto il progetto: Adriatica S.r.l. Semplificata si occupa di consulenza e progettazione, direzione lavori, gestione dei cantieri e controllo qualità, fino alla consegna.",
      "Nessun pensiero per te: definiamo insieme obiettivi, tempi e budget all'inizio, e ti teniamo aggiornato a ogni passo. Il risultato è un cantiere ordinato, tempi rispettati e un lavoro consegnato completo in ogni dettaglio.",
    ],
    bodyEn: [
      "With the turnkey formula you have a single point of contact for the entire project: Adriatica S.r.l. Semplificata handles consulting and design, works management, site coordination and quality control, right through to delivery.",
      "No worries for you: we define goals, timing and budget together at the start, and keep you updated at every step. The result is a well-run site, respected deadlines and a job delivered complete in every detail.",
    ],
    includes: [
      "Consulenza iniziale e progettazione",
      "Direzione lavori e coordinamento tecnico",
      "Gestione completa dei cantieri",
      "Controllo qualità in ogni fase",
      "Rispetto dei tempi e dei costi concordati",
      "Consegna finale completa e assistenza post-intervento",
    ],
    includesEn: [
      "Initial consulting and design",
      "Works management and technical coordination",
      "Complete site management",
      "Quality control at every phase",
      "Respect for agreed timing and costs",
      "Complete final delivery and after-service support",
    ],
    detrazioni: false,
  },
};

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Sopralluogo e preventivo",
    titleEn: "Site visit and quote",
    text: "Ascoltiamo le tue esigenze, visitiamo l'immobile e prepariamo un preventivo chiaro.",
    textEn: "We listen to your needs, visit the property and prepare a clear quote.",
  },
  {
    n: "02",
    title: "Progetto",
    titleEn: "Design",
    text: "Definiamo insieme soluzioni, materiali, tempi e costi. Nessuna sorpresa dopo.",
    textEn: "We define solutions, materials, timing and costs together. No surprises later.",
  },
  {
    n: "03",
    title: "Cantiere",
    titleEn: "Worksite",
    text: "Realizziamo i lavori con team tecnico qualificato e controllo qualità costante.",
    textEn: "We carry out the works with a qualified technical team and constant quality control.",
  },
  {
    n: "04",
    title: "Consegna",
    titleEn: "Delivery",
    text: "Consegniamo il lavoro completo e restiamo disponibili con l'assistenza post-intervento.",
    textEn: "We deliver the finished work and stay available with after-service support.",
  },
];

export { DOMAIN };
